const KEY = "serial_number";

const api = {
  get: () => sessionStorage.getItem(KEY),
  set: (serialNumber: string) => sessionStorage.setItem(KEY, serialNumber),
  remove: () => sessionStorage.removeItem(KEY),
};

export default api;
